// import React, { useEffect, useState } from "react";
// import recentImg1 from "../assets/recent-img1.jpg";
// import recentImg2 from "../assets/recent-img2.jpg";
// import recentImg3 from "../assets/recent-img3.jpg";
// import "../components/componentstyle/recentImgslide.css";

// // const images = [recentImg1, recentImg2, recentImg3];
// const images = [
//   {
//     image: recentImg1,
//     text: " Lorem ipsum dolor sit amet, consectetur adipiscing elit .Curabitur tempor finibus risus. Vivamus quis aliquet nibh.Nunc vitae felis nunc. Nam scelerisque maximus tempor. Proinsed euismod tellus. Nunc sodales, quam et porttitor accumsan,lectus dolor laoreet dolor, a scelerisque.",
//   },
//   {
//     image: recentImg2,
//     text: " Nunc vitae felis nunc. Nam scelerisque maximus tempor. Proin sed euismod tellus. Nunc sodales, quam et porttitor accumsan, lectus dolor laoreet dolor, a scelerisque.",
//   },
//   {
//     image: recentImg3,
//     text: " Lorem ipsum dolor sit amet, consectetur adipiscing elit .Curabitur tempor finibus risus. Vivamus quis aliquet nibh.Nunc vitae felis nunc.",
//   },
// ];

// function RecentImgeSlider() {
//   const [startIndex, setStartIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setStartIndex((prev) => (prev + 1) % images.length);
//     }, 8000);
//     return () => clearInterval(interval);
//   }, []);

//   const getVisibleImages = () => {
//     return [
//       images[startIndex % images.length],
//       images[(startIndex + 1) % images.length],
//       images[(startIndex + 2) % images.length],
//     ];
//   };

//   return (
//     <div className="slider-wrapper">
//       <h2>
//         <span className="highlight">Recent</span> Events
//       </h2>
//       <div className="image-slider">
//         {getVisibleImages().map((item, index) => (
//           <div className="slide-card" key={index}>
//             <div className="imgeDiv">
//               <img src={item.image} alt={`Slide ${index} `} />
//             </div>
//             <div className="d-flex gap-4">
//               <h3>Recent Event Detail</h3>
//               <div className="underline"></div>
//             </div>
//             <p>{item.text}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default RecentImgeSlider;

import React, { useEffect, useState } from "react";
import recentImg1 from "../assets/recent-img1.jpg";
import recentImg2 from "../assets/recent-img2.jpg";
import recentImg3 from "../assets/recent-img3.jpg";
import "../components/componentstyle/recentImgslide.css";

const images = [
  {
    image: recentImg1,
    text: "Slide 1 description...",
  },
  {
    image: recentImg2,
    text: "Slide 2 description...",
  },
  {
    image: recentImg3,
    text: "Slide 3 description...",
  },
];

function RecentImageSlider() {
  const [startIndex, setStartIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true); // Trigger animation
      setTimeout(() => setAnimate(false), 600); // remove animation class after it ends
      setStartIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const getVisibleImages = () => {
    return [
      images[startIndex % images.length],
      images[(startIndex + 1) % images.length],
      images[(startIndex + 2) % images.length],
    ];
  };

  return (
    <div className="slider-wrapper">
      <h2>
        <span className="highlight">Recent</span> Events
      </h2>
      <div className="image-slider-wrapper container">
        <div className={`image-slider ${animate ? "slide-animation" : ""}`}>
          {getVisibleImages().map((img, index) => (
            <div className="slide-card" key={index}>
              <div className="imgeDiv">
                <img src={img.image} alt={`Slide ${index}`} />
              </div>
              <div className="d-flex gap-4">
                <h3>Recent Event Detail</h3>
                <div className="underline"></div>
              </div>
              <p>{img.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RecentImageSlider;
